import React from "react";
import CTable from "components/common/Table";
// import Link from "components/common/Link";
import { withRouter } from "react-router";
import Switch from "components/common/Switch";

const ManufacturerList = ({ data, loading, handleStatusManufacturer }) => {
  const columns = [
    {
      field: "name",
      headerName: "Name of Vehicle Manufacturer",
    },
    {
      field: "vehicle_model",
      headerName: "No. of Vehicle Model",
    },

    {
      field: "vehicle_connector",
      headerName: "No. of Variants",
    },

    // {
    //   field: "action",
    //   headerName: "Action",
    //   valueGetter: (v, d) => {
    //     // const manufacturer = {
    //     //   pathname: "/view/details",
    //     //   manufacturerDetailsId: { id: d.manufacturer_id, name: d.name },
    //     // };
    //     return (
    //       <>
    //         {/* {
    //           <>
    //             <Link style={{ textDecoration: "none" }} href={manufacturer}>
    //             <img
    //           src="../images/share.svg"
    //           alt="share"
    //           style={{ width: "25px"  }}
    //         ></img>
    //             </Link>
    //           </>
    //         } */}

    //         {
    //           <Switch
    //             checked={d.status === 1 ? true : false}
    //             onClick={() =>
    //               handleStatusManufacturer(d.manufacturer_id, d.status)
    //             }
    //           />
    //         }
    //       </>
    //     );
    //   },
    // },
  ];

  return (
    <CTable
      columns={columns}
      data={data}
      isLoading={loading?.isLoading}
      pagination={true}
      localPagination={true}
      page={0}
      rowsPerPage={5}
    ></CTable>
  );
};

export default withRouter(ManufacturerList);
